import { useEffect, useState } from 'react';

const useConsoleConverTags = () => {
  const [consoleConverTagsVisible, setConsoleConverTagsVisible] =
    useState(false);

  const isConsoleConverTagsVisible = () => {
    try {
      const visible =
        localStorage.getItem('console/console-conver-tags-visible') || 'false';

      return visible === 'true';
    } catch {
      return false;
    }
  };

  const toggleConsoleConverTagsVisible = () => {
    try {
      const newVal = !isConsoleConverTagsVisible();
      localStorage.setItem(
        'console/console-conver-tags-visible',
        newVal.toString()
      );
      setConsoleConverTagsVisible(newVal);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  useEffect(() => {
    setConsoleConverTagsVisible(isConsoleConverTagsVisible());
  }, []);

  return {
    consoleConverTagsVisible,
    isConsoleConverTagsVisible,
    toggleConsoleConverTagsVisible,
  };
};

export default useConsoleConverTags;
